/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC } from "react";
import FileInput from "src/components/atoms/inputs/FileInput";
import FileList, { FileListProps } from "./FileList";
import { fileListContainer } from "../styles";

interface FileListWithInputProps extends FileListProps {
  disabledButton?: boolean;
  uploadFiles: (files: FileList) => void;
}

const FileListWithInput: FC<FileListWithInputProps> = ({
  disabledButton,
  uploadFiles,
  ...props
}) => (
  <div css={fileListContainer}>
    <FileList {...props} />
    {!props.disabled && (
      <FileInput onFileChange={uploadFiles} disabled={disabledButton} />
    )}
  </div>
);

export default FileListWithInput;
